import React, { useContext, useEffect, useState } from 'react';
import ReactCountryFlag from "react-country-flag";
import { FormControl, InputLabel, MenuItem, Popover, Select } from '@mui/material';
import AuthContext from '../../authContext';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { changeCurrency, changeLanguage } from '../../../redux/productSlice';
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { Row, Col, Button, Form, Input } from "antd";
import InfoIcon from '@mui/icons-material/Info';
import { useNavigate } from 'react-router-dom';


const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "fit-content",
  bgcolor: "background.paper",
  border: "2px solid #ACACAC",
  borderRadius: "1em",
  boxShadow: 24,
  display:'flex',
  flexDirection:'column',
  p: 4,
};

export default function LanCurrSelect() {
  const language = useSelector((state) => state.products.selectedLanguage[0].Language);
  const currency = useSelector((state) => state.products.selectedCurrency[0].currency);
  const user = useSelector((state) => state.products.userInfo);
  const [anchorEl, setAnchorEl] = useState(null);
  const [isHovered, setIsHovered] = useState(false);
  const authCtx = useContext(AuthContext);
  const dispatch= useDispatch();
  const navigate = useNavigate()
  const [openmodal, setOpenmodal] = useState(false)

  
  const getToken = () => {
    return localStorage.getItem("token");
  };

  const token = getToken();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  
  const handleCloseModal = () => {
    setOpenmodal(false);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;
  
  const handleChangeCurrency = async (event) => {
    const cur = event.target.value;
    
    // Check for currency and currencyRate
    if (currency === 'eur' && !authCtx.currencyRate) {  
        return setOpenmodal(true)
    }
  
    dispatch(changeCurrency({ currency: cur }));
  
    try {
      await axios.put(
        `${process.env.REACT_APP_TESTING_API}/users/${user.id}`,
        { currency: cur },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } catch (error) {
      console.error("Error updating currency:", error);
    }
  };
  


  const handleChangeLanguage = async (event) => {
    const lan = event.target.value;
      dispatch(changeLanguage({ Language: lan }));
    try {
      await axios.put(
        `${process.env.REACT_APP_TESTING_API}/users/${user.id}`,
        { 'language':lan },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } catch (error) {
      console.error("Error updating language:", error);
    }
  };

  const defaultStyle = {
    padding:'15px 20px 5px 20px',
    top:'0',
    color:'#fff',
    textAlign:'center',
    border:'1px solid transparent',
    width: '170px',
    borderRadius:'0 40px 0px 40px',
    fontSize:'calc(0.7rem + 0.3vw)',
    backgroundColor:'var(--primary-color)',
    transition: "background-color 0.3s, color 0.3s", // Smooth transition
  };

  const hoverStyle = {
    backgroundColor: "#fff",
    color: "var(--primary-color)",
    border:'1px solid var(--primary-color)',
  };

  // Toggle the hover state
  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  // console.log(authCtx.selectedcurrency)
  // console.log(currency)
  return (
    <>
    <button style={isHovered ? { ...defaultStyle, ...hoverStyle } : defaultStyle}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    onClick={handleClick}
    variant="contained">
      {language === 'eng' ? 'English' : 'Français'} / {currency === 'eur' ? 'EUR' : 'USD'}
    </button>
  <Popover
    id={id}
    open={open}
    anchorEl={anchorEl}
    onClose={handleClose}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'left',
    }}
  >
                  <div style={{width:'fit-content', display:'flex',flexDirection:'column', rowGap:'0.2rem'}}>
                  
      <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>
        <InputLabel id="demo-simple-select-standard-label">Currency</InputLabel>
                <Select
                  style={{
                    margin: "0 ",
                    border: "none",
                    background: "#fff",
                    borderRadius: "5px",
                  }}
                  labepd="demo-simple-select-standard-label"
                  id="demo-simple-select-standard"
                  value={language}
                  onChange={handleChangeLanguage}
                  label='Currency'
                >
                  <MenuItem value={"fr"}>
                    <span style={{ paddingRight: "5px" }}>
                      <ReactCountryFlag countryCode="FR" svg />
                    </span>
                    Français
                  </MenuItem>
                  <MenuItem value={"eng"}>
                    <span style={{ paddingRight: "5px" }}>
                      <ReactCountryFlag countryCode="GB" svg />
                    </span>
                    English 
                  </MenuItem>
                  {/* <MenuItem value={"Arabic"}>
                    <span style={{ paddingRight: "5px" }}>
                    <ReactCountryFlag countryCode="LB" svg />
                    </span>
                    Arabic
                  </MenuItem> */}
                </Select>
                </FormControl>
      <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>
        <InputLabel id="demo-simple-select-standard-label">Currency</InputLabel>
                <Select
                  style={{
                    margin: "0 ",
                    border: "none",
                    background: "#fff",
                    borderRadius: "5px",
                  }}
                  labepd="demo-simple-select-standard-label"
                  id="demo-simple-select-standard"
                  value={currency}
                  onChange={handleChangeCurrency}
                  label='Currency'
                >
                  <MenuItem value={"eur"} >Euro (€)</MenuItem>
                  <MenuItem value={"usd"}>Dollar ($)</MenuItem>
                </Select>
                </FormControl>
                </div>
                {/* <div style={{display:'grid',gridTemplateColumns:'repeat(2, 46%)', columnGap:'8%' }}>
                  <button style={{background:"var(--primary-color)", borderRadius:'10px', color:'#fff'}}>Cancel</button>
                  <button style={{background:"#d3d3d3", borderRadius:'10px', color:'#000'}}>Save</button>
                </div> */}
    </Popover>
    
    <Modal
        open={openmodal}
        onClose={handleCloseModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <InfoIcon style={{color:"red",margin:"0 auto .5em auto",fontSize:"3em"}}/>
        <h3 style={{color:"red"}}>{language === "eng" ? "You cannot change the currency. Please contact the administration." : "Vous ne pouvez pas changer la devise. Veuillez contacter l\'administration."}</h3>
        <div style={{width:'fit-content',margin:'auto',display:'flex',flexWrap:'wrap'}}>
        <Button 
           onClick={()=>{handleCloseModal(); navigate(`/contactus`)}}
          style={{backgroundColor:'var(--primary-color)',color: 'white', height:'3em',width:'10em',borderRadius:'3em 0',margin:'2em auto 0 auto'}}>
            {language === "eng" ? "Contact us" : "Nous contacter"}
          </Button>
          </div>
        </Box>
      </Modal>
    </>
  );
}
